'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [],
        _n = !0,
        _d = !1,
        _e = void 0;

    try {
      for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i['return'] && _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) return arr;
    if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  };
}(),
    _utils = require('../utils');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

var validProperties = ['display', 'position', 'top', 'right', 'bottom', 'left', 'width', 'minWidth', 'maxWidth', 'height', 'minHeight', 'maxHeight', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'zIndex', 'flex', 'flexGrow', 'flexShrink', 'flexBasis', 'alignSelf', 'float'],
    filterLayoutStyles = function filterLayoutStyles(styles) {
  if (styles === void 0) return {};
  var filteredStyles = (0, _utils.entries)(styles).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if ('object' === ('undefined' == typeof value ? 'undefined' : _typeof(value))) {
      if (0 !== key.indexOf('@media')) return accumulator;
      var filteredValue = (0, _utils.entries)(value).reduce(function (mediaAccumulator, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            mediaKey = _ref4[0],
            mediaValue = _ref4[1];

        return 'object' === ('undefined' == typeof mediaValue ? 'undefined' : _typeof(mediaValue)) ? mediaAccumulator : _extends({}, mediaAccumulator, _defineProperty({}, mediaKey, mediaValue));
      }, {});
      return _extends({}, accumulator, _defineProperty({}, key, filteredValue));
    }

    return validProperties.includes(key) ? _extends({}, accumulator, _defineProperty({}, key, value)) : accumulator;
  }, {});
  return filteredStyles;
};

exports.default = filterLayoutStyles;